module.exports = __webpack_public_path__ + "static/media/pruef03.1b28df8e.jpeg";